import { CommonModule } from '@angular/common';

import { NgModule } from '@angular/core';

import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';

import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';

import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';

import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';

import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

import { RouterModule } from '@angular/router';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { SimplebarAngularModule } from 'simplebar-angular';

import { DaveListCardModule } from '../../../dave-list-card/dave-list-card.module';

import { AppButtonModule } from '../../../dave-utils-module/app-button-module/app-button.module';

import { NewReportDialogComponent } from './new-report-dialog.component';







































































@NgModule({
    imports: [CommonModule, AppButtonModule, MatDialogModule, MatTooltipModule, MatFormFieldModule, MatSelectModule, MatListModule, SimplebarAngularModule, FontAwesomeModule, RouterModule, MatCardModule, DaveListCardModule],
    declarations: [NewReportDialogComponent],
    exports: [NewReportDialogComponent],
})
export class NewReportDialogModule {}
